<template>
    <div>
        <breadcrumbs
                :title="'Administratori'"
                :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Uredi administratora: {{ ime }} {{ prezime }}</h5>
            </div>
            <div class="ibox-content">
                <administrator-forma
                        :disabled="false"
                        :id="id"
                        :modal="false"
                        :action="'edit'"
                        @returnData="setData"
                >
                </administrator-forma>
            </div>
        </div>
    </div>

</template>

<script>
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";
import AdministratorForma from "@/views/pages/Administratori/AdministratorForma";

export default {
name: "AdministratorEdit",
    components: { AdministratorForma, Breadcrumbs },
    data(){
        return {
            id: this.$route.params.admin_id,
            breadcrumbs: [],
            ime: '',
            prezime: '',
        }
    },
    methods:{
        setBreadcrumbs() {
            this.breadcrumbs = [
                {
                    path: '/administratori',
                    name: 'Administratori'
                },
                {
                    path: ( '/administratori/' + this.id ),
                    name: ( 'Administrator: ' + this.ime + ' ' + this.prezime )
                },
                {
                    path: ( '/administratori/' + this.id + '/edit' ),
                    name: ( 'Uredi administratora: ' + this.ime + ' ' + this.prezime )
                }
            ]
        },
        setData( data ){
            this.ime = data.ime ? data.ime : ''
            this.prezime = data.prezime ? data.prezime : ''
            this.setBreadcrumbs()
        }
    }
}
</script>

<style scoped>

</style>